import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                      */
const OptionalFieldset = ({
  className,
  labels,
  active,
  children,
  ...rest
}) => active ? /* @__PURE__ */ React.createElement("fieldset", { ...rest, className: classnames("optional-fieldset", className) }, /* @__PURE__ */ React.createElement("legend", { className: "optional-fieldset__legend" }, /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1", component: "h3" }, labels.legend)), /* @__PURE__ */ React.createElement("div", { className: "optional-fieldset__content" }, children)) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
export {
  OptionalFieldset,
  OptionalFieldset as default
};
//# sourceMappingURL=OptionalFieldset.js.map
